import Footer from "../../components/Footer";
import Header from "../../components/Header";
import styles from "./terms.module.css";

const Terms = () => {

  return (<>
    <Header />

    <div>
      <div className={`${styles.BannerSec}`}>
        <img src="/images/contact-us-banner1.jpg" alt="" />
        <div className={`${styles.BannerTitleCU}`}>
          <div className={`${styles.Container}`}>
            <h1 className={`${styles.Heading}`}>Terms and Conditions</h1>
          </div>
        </div>
      </div>
      <div className={`${styles.contactpg}`}>
        <div className={`${styles.Container}`}>
          <h2>Terms and Conditions</h2>
          <p>Effective Date: 01/05/2025</p>
          <p>Welcome to Ezy Freight Logistics. Please read these Terms and Conditions ("Terms") carefully before using our website (www.eflogistics.io) and associated services ("Services"). By accessing or using our Services, you agree to be bound by these Terms.</p>
          <p>If you do not agree with these Terms, you must not access or use our Services.</p>
          <p>1. Definitions</p>
          <p>- "Customer", "User", "You": Any individual, company, or entity that registers for, accesses, or uses our Services.</p>
          <p>- "Software": Our cloud-based logistics platform, Ezy Freight Logistics.</p>
          <p>2. Use of Services</p>
          <p>2.1. You must be at least 18 years old and capable of entering into legally binding contracts.</p>
          <p>2.2. You agree to use the Services only for lawful purposes and in accordance with these Terms.</p>
          <p>2.3. You are responsible for ensuring that your login credentials are kept confidential. You must notify us immediately of any unauthorised use of your account.</p>
          <p>3. Subscriptions and Payment</p>
          <p>3.1. Access to the Services may require the purchase of a subscription. Details of pricing and plans are available on our website or provided to you separately.</p>
          <p>3.2. All fees are quoted in GBP and are exclusive of VAT unless otherwise stated.</p>
          <p>3.3. Payment obligations are non-cancellable, and fees paid are non-refundable except as expressly stated in these Terms.</p>
          <p>3.4. We reserve the right to change our fees or introduce new charges with prior notice.</p>
          <p>4. Intellectual Property</p>
          <p>4.1. We retain all intellectual property rights in and to our Services, including but not limited to our Software, branding, and content.</p>
          <p>4.2. You are granted a limited, non-exclusive, non-transferable licence to access and use the Services for your internal business purposes.</p>
          <p>4.3. You may not copy, modify, distribute, sell, or lease any part of our Services without our prior written consent.</p>
          <p>5. Data Protection and Privacy</p>
          <p>5.1. Your privacy is important to us. Please review our Privacy Policy below:</p>
          <p>Privacy Policy</p>
          <p>Effective Date: 01/05/2025</p>
          <p>At Ezy Freight Logistics ("EFL", "we", "us", or "our"), we are committed to protecting your personal data and respecting your privacy.</p>
          <p>1. Information We Collect:</p>
          <p>- Account Information: When you register, we collect your name, company details, email address, and contact information.</p>
          <p>- Usage Data: We collect information on how you use our Services to improve user experience.</p>
          <p>- Payment Information: We use secure third-party processors to handle payment details.</p>
          <p>2. How We Use Your Information:</p>
          <p>- To provide, operate, and maintain our Services.</p>
          <p>- To communicate with you regarding updates, support, and promotional offers.</p>
          <p>- To comply with legal obligations.</p>
          <p>3. Sharing Your Information:</p>
          <p>- We do not sell your personal data.</p>
          <p>- We may share your data with trusted third-party service providers necessary to deliver our Services.</p>
          <p>- We may disclose your information if required by law.</p>
          <p>4. Data Security:</p>
          <p>- We implement appropriate technical and organisational measures to protect your personal data.</p>
          <p>5. Your Rights:</p>
          <p>- You have the right to access, rectify, or erase your personal data.</p>
          <p>- You may object to processing or request data portability.</p>
          <p>6. Cookies:</p>
          <p>- We use cookies to enhance your browsing experience. You can manage cookie preferences through your browser settings.</p>
          <p>7. Retention:</p>
          <p>- We retain personal data only as long as necessary to fulfil the purposes we collected it for.</p>
          <p>8. International Data Transfers:</p>
          <p>- If we transfer your data outside the UK, we ensure appropriate safeguards are in place.</p>
          <p>9. Changes to This Policy:</p>
          <p>- We may update this Privacy Policy. We encourage you to review it regularly.</p>
          <p>10. Contact Us:</p>
          <p>If you have any questions about this Privacy Policy, please contact us at:</p>
          <p>Ezy Freight Logistics</p>
          <p>Email: admin@eflogistics.io</p>
          <p>Registered Address: Unit 2&3 Bay Close, Progress Way, Luton, Beds, England, LU4 9UP</p>
          <p>5.2. You acknowledge that use of the Services may involve the transmission of personal data, and you warrant that you have obtained all necessary consents to do so.</p>
          <p>6. Service Availability</p>
          <p>6.1. We endeavour to ensure the Services are available 24/7 but do not guarantee uninterrupted access.</p>
          <p>6.2. We may temporarily suspend access to the Services for maintenance, updates, or other reasons without prior notice.</p>
          <p>7. Warranties and Disclaimers</p>
          <p>7.1. The Services are provided on an "as is" and "as available" basis.</p>
          <p>7.2. We disclaim all warranties, whether express or implied, including, but not limited to, implied warranties of merchantability, fitness for a particular purpose, and non-infringement.</p>
          <p>7.3. We do not warrant that the Services will be error-free, secure, or free from viruses or other harmful components.</p>
          <p>8. Limitation of Liability</p>
          <p>8.1. To the maximum extent permitted by law, EFL shall not be liable for any indirect, incidental, special, consequential or punitive damages, or any loss of profits or revenues, arising out of your use of the Services.</p>
          <p>8.2. Our total liability for any claim under these Terms shall not exceed the amount paid by you to us in the 12 months preceding the event giving rise to the liability.</p>
          <p>9. Termination</p>
          <p>9.1. We may suspend or terminate your access to the Services if you breach these Terms.</p>
          <p>9.2. Upon termination, your right to use the Services will immediately cease.</p>
          <p>9.3. Sections 4, 5, 7, 8, 9, and 10 shall survive termination.</p>
          <p>10. Governing Law and Jurisdiction</p>
          <p>10.1. These Terms shall be governed by and construed in accordance with the laws of England and Wales.</p>
          <p>10.2. Any disputes arising out of or in connection with these Terms shall be subject to the exclusive jurisdiction of the courts of England and Wales.</p>
          <p>11. Changes to These Terms</p>
          <p>11.1. We reserve the right to modify these Terms at any time. Changes will be effective immediately upon posting to our website.</p>
          <p>11.2. Your continued use of the Services following the posting of changes constitutes your acceptance of such changes.</p>
          <p>12. Contact Us</p>
          <p>If you have any questions about these Terms, please contact us at:</p>
          <p>Ezy Freight Logistics</p>
          <p>Email: admin@eflogistics.io</p>
          <p>Registered Address: Unit 2&3 Bay Close, Progress Way, Luton, Beds, England, LU4 9UP</p>
          <p>Thank you for using Ezy Freight Logistics!</p>
        </div>
      </div>
    </div>

    <Footer />

  </>);
};

export default Terms;